export default __webpack_public_path__ + "static/media/vid3.9fb60e4b.mp4";